import { createElement, useMemo } from 'react';
import Script from 'next/script';
import type { UnidaysIntegration as UnidaysIntegrationSchema } from '@amplience/content-types/typings/c-unidays-integration';
import { getSingleAmplienceImageUrl } from '@storefront/lib-global/partials/image/ImagePartialUtils';
import { useViewportWidth } from '../../utils';
import { UnidaysIntegrationContainer } from './UnidaysIntegration.styles';

export type UnidaysIntegrationProps = UnidaysIntegrationSchema;

export function UnidaysIntegration({
  mobileImage,
  desktopImage,
  mobileImageAltText,
  desktopImageAltText,
}: UnidaysIntegrationProps) {
  const viewportWidth = useViewportWidth();

  const mobileImageSrc = getSingleAmplienceImageUrl(
    mobileImage?.image?.defaultHost,
    mobileImage?.image?.endpoint,
    mobileImage?.image?.name,
    mobileImage?.assetType,
  );

  const desktopImageSrc = getSingleAmplienceImageUrl(
    desktopImage?.image?.defaultHost,
    desktopImage?.image?.endpoint,
    desktopImage?.image?.name,
    desktopImage?.assetType,
  );

  const isMobile = useMemo(() => viewportWidth <= 674, [viewportWidth]);
  const storefrontUrl = useMemo(() => process.env.STOREFRONT_CDN_URL, []);
  const clientId = useMemo(() => process.env.NEXT_PUBLIC_UNIDAYS_CLIENT_ID, []);
  const partnerId = useMemo(() => process.env.NEXT_PUBLIC_UNIDAYS_PARTNER_ID, []);

  return (
    <UnidaysIntegrationContainer data-testid="unidays-student-discount">
      <Script id="unidays-access" src="https://access.myunidays.com/unidays-partner-component.min.js" />
      {createElement('unidays-access', {
        clientid: clientId,
        redirecturi: `${storefrontUrl}/en-gb/student-discount`,
        locale: 'en-GB',
        mobileimage: mobileImageSrc,
        desktopimage: desktopImageSrc,
        imagealttext: isMobile ? mobileImageAltText : desktopImageAltText,
        partnerid: partnerId,
      })}
    </UnidaysIntegrationContainer>
  );
}
